import React , {useState, useEffect, useRef} from 'react'
import { styled } from "@mui/material/styles";
import { makeStyles } from "@material-ui/core";
import { Tree, Input, Button, Dropdown, Menu, Select, Checkbox, Spin  } from 'antd';
import { PlusOutlined, ExclamationCircleOutlined, SwapOutlined } from '@ant-design/icons';
import Modal from "@mui/material/Modal";

import fileIcon from "../../assets/images/icon-pdf.png";

import {
  createOrder,
  getFileStatus
} from '../../actions/index'
import { setDisplayName } from 'recompose';

const { Option } = Select;
const useStyles = makeStyles({
	translateBox: {
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		width: "360px",
		maxWidth: "90vw",
		padding: '32px 32px 24px',
		background: "#fff",
		boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.2)",
		borderRadius: "6px",
	},
	translateTitle: {
		display: 'flex',
		alignItems: 'center',
		fontSize: '16px',
		marginBottom: '10px',
		color: 'rgba(0, 0, 0, 0.85)',
		'& .anticon': {
			marginRight: '16px'
		}
	},
	modalTip: {
		fontSize: '14px',
		color: '#666',
		lineHeight: '24px'
	},
	boldText: {
		fontWeigh: 'bold',
		margin: '0 5px',
		color: '#333'
	},
	btnLine: {
		marginTop: '15px',
		display: 'flex',
		flexDirection: 'column',
		width: '296px',
		margin: '0 auto',
		'& button': {
			marginBottom: '10px'
		}
	},
	pdfIcon: {
		display: 'flex',
		justifyContent: 'center',
		marginBottom: '10px',
		'& img': {
			width: '40px'
		}
	},
	fileName: {
		fontSize: '14px',
		lineHeight: '21px',
		color: '#333'
	},
	optionLine: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		margin: '10px 0',
	},
	smallSelect: {
		width: '120px'
	},
	exchangeIcon: {
		margin: '0 15px',
		cursor: 'pointer'
	},
	flexCenter: {
		width: '100%',
		height: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	}
});
export default function TranslateModal(props) {
  const { openModal, handleClose, showFile, refresh, translateFile, doTranslate, toViewFile, backTranslate, toTranslate, peopelTranslateValue } = props
  const classes = useStyles();
	
	const [langFrom, setLangFrom] = useState('zh-cn')
	const [langTo, setLangTo] = useState('en')
	const [langAuto, setLangAuto] = useState(true)
	const [loading, setLoading] = useState(false)
	const [isError, setIsError] = useState(false)
	const [isTranslating, setIsTranslating] = useState(false)
	const [translatedFile, setTranslatedFile] = useState(null)
	const [peopelTranslate, setPeopelTranslate] = useState(false)
	const [needStrCount, setNeedStrCount] = useState('')
	const [hasStrCount, setHasStrCount] = useState('')
	const [fileData, setFileData] = useState({})

	const inputRef = useRef()
	
	const langList = [
		{
			label: '简体中文',
			key: 'zh-cn'
		},
		{
			label: '英语',
			key: 'en'
		},
		// {
		// 	label: '德语',
		// 	key: 'dr'
		// },
		// {
		// 	label: '法语',
		// 	key: 'fr'
		// },
		// {
		// 	label: '俄语',
		// 	key: 'es'
		// },
		// {
		// 	label: '日语',
		// 	key: 'ja'
		// },
		// {
		// 	label: '韩语',
		// 	key: 'ha'
		// },
		// {
		// 	label: '西班牙语',
		// 	key: 'xa'
		// },
	]

	useEffect(() => {
		if (openModal && !peopelTranslateValue) {
			checkFileStatus()
		}
	}, [openModal, peopelTranslateValue])

	const closeModal = () => {
		setIsError(false)
		setTranslatedFile(null)
		setIsTranslating(false)
		setNeedStrCount('')
		setHasStrCount('')
		setPeopelTranslate(false)
		handleClose()
	}

	const checkFileStatus = () => {
		setLoading(true)
		getFileStatus({
			base_file_id: translateFile.base_file_id
		}).then(res => {
			setLoading(false)
			setFileData(res)
			setNeedStrCount(res.char_numbers)
			setHasStrCount(res.balance)
			setLangFrom(res.file_language == '英文' || res.file_language == 'en' ? 'en' : 'zh-cn')
			if (!refresh) {
				// 是否支持翻译
				setIsError(!res.is_file_editable)
				// 是否正在翻译
				setIsTranslating(res.is_translating)
				// 是否已有翻译件
				if (res.translated_file && res.translated_file.length > 0) {
					setTranslatedFile(res.translated_file[0])
				}
			}
		}).catch(() => {
			setLoading(false)
		})
	}

	const onChangeTranslateForm = (value, key) => {
    if (key == 'from') {
			setLangFrom(value)
		} else if (key == 'to') {
			setLangTo(value)
		} else if (key == 'auto') {
			setLangAuto(value)
		}
  }

	const exchangeLang = () => {
		let from = langFrom
		setLangFrom(langTo)
		setLangTo(from)
	}

	const doPeopelTranslate = () => {
		setPeopelTranslate(true)
	}

	const doBackTranslate = () => {
		setPeopelTranslate(false)
		backTranslate()
	}

	const toView = () => {
		toViewFile(translatedFile.mono_url, translatedFile.dual_url)
	}

	const submit = () => {
		sessionStorage.setItem('langTo', langTo)
		if (refresh) {
			sessionStorage.setItem('translateFile', JSON.stringify(translateFile))
		}
		doTranslate()
	}

  return (
		<Modal
			open={openModal}
			onClose={closeModal}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
		>
			<div className={classes.translateBox}>
				{
					isError || isTranslating || translatedFile ? 
					<>
						{
							isError ?
							<>
								<div className={classes.modalTip}>当前程序无法翻译图片、扫描件等</div> 
								<div className={classes.modalTip}>如需译前、译后排版，人工审校等服务请将需求发送至邮箱 <span className={classes.greenText}>service@msecu.com</span>，由项目组为您跟进</div>
							</> : 
							<>
								{
									isTranslating ? 
									<div className={classes.modalTip}>当前公司已有用户正在翻译该文件，请稍候</div> 
									:
									<div className={classes.modalTip}>当前文件已有翻译结果，是否查看翻译件</div> 
								}
							</>
						}
						<div className={classes.btnLine}>
							{
								translatedFile ? 
								<>
									<Button type="primary" onClick={toView}>是</Button>
									<Button type="primary" onClick={closeModal}>否</Button>
								</> 
								:
								<Button type="primary" onClick={closeModal}>确定</Button>
							}
						</div>
					</>
					: 
					<>
						{
							showFile && 
							<>
								<div className={classes.pdfIcon}>
									<img src={fileIcon} />
								</div>
								<div className={classes.fileName}>
									{translateFile.file_name}
								</div>
								<div className={classes.optionLine}>
									<Select
										className={classes.smallSelect}
										placeholder="请选择"
										value={langFrom}
										onChange={(e) => onChangeTranslateForm(e, 'from')} 
									>
										{
											langList.map((v, i) => {
												return (
													<Option value={v.key} key={i}>{v.label}</Option>
												)
											})
										}
									</Select>
		
									<SwapOutlined onClick={exchangeLang} className={classes.exchangeIcon}/>
		
									<Select
										className={classes.smallSelect}
										placeholder="请选择"
										value={langTo}
										onChange={(e) => onChangeTranslateForm(e, 'to')} 
									>
										{
											langList.map((v, i) => {
												return (
													<Option value={v.key} key={i}>{v.label}</Option>
												)
											})
										}
									</Select>
								</div>
								<div className={classes.btnLine}>
									<Button type="primary" onClick={submit}>确定</Button>
									<Button type="default" onClick={backTranslate}>取消</Button>
								</div>
							</>
						}
						{
							!showFile && (
								loading ? 
								<div className={classes.flexCenter}>
									<Spin/>
								</div>
								: 
								<>
									<div className={classes.translateTitle}>
										<ExclamationCircleOutlined style={{color: '#faad14', fontSize: '22px'}} /> 提示
									</div>
									{
										(peopelTranslate || peopelTranslateValue) ? 
										<>
											<div className={classes.modalTip}>如需人工翻译服务请联系客服，或将需求发送至邮箱 <span className={classes.greenText}>service@msecu.com</span></div> 
											<div className={classes.modalTip}>由项目组为您跟进</div> 
											<div className={classes.btnLine}>
												<Button type="default" onClick={doBackTranslate}>返回</Button>
											</div>
										</> : 
										<>
											<div className={classes.modalTip}>
												企业在线翻译剩余 { hasStrCount } 字符
											</div> 
											<div className={classes.modalTip}>
												本次翻译预计消耗 <span className={classes.greenText}>{ needStrCount }</span> 字符
											</div> 
											{
												hasStrCount >= needStrCount ? 
												<div className={classes.modalTip}>翻译完成的稿件可前往<span className={classes.boldText}>个人中心-我的翻译</span>查看</div> 
												:
												<div className={classes.modalTip}>可用翻译字符数不够，请联系客服</div> 
											}
											<div className={classes.btnLine}>
												<Button type="default" onClick={doPeopelTranslate}>人工翻译</Button>
												{
													hasStrCount >= needStrCount &&
													<Button type="primary" onClick={toTranslate}>在线翻译（免费）</Button>
												}
												<Button type="default" onClick={closeModal}>取消</Button>
											</div>
										</>
									}
								</>
							)
						}
					</>
				}
				
			</div>
		</Modal>
  )
}
